export const idx_data_angle = [];

idx_data_angle.push({
  angle: '---',
});

for (let i = 0; i <= 90; i += 5) {
  idx_data_angle.push({
    angle: i + '',
  });
}

export const idx_data_angle_1 = [];

idx_data_angle_1.push({
  angle: '---',
});

for (let i = 0; i <= 90; i++) {
  idx_data_angle_1.push({
    angle: i + '',
  });
}
